import React from 'react'
import { useSelector, useDispatch } from 'react-redux'; 
import { useNavigate } from 'react-router-dom';
import { setProductsByCategory } from '../Store/Slices/ProductsSlice/ProductsSlice';

export const Navbar = ({setCategoryText}) => {

    const data = useSelector((state)=>state.products.active);

    const dispatch = useDispatch();

    const navigate = useNavigate();
    const handleActive=(e)=>{
        setCategoryText(e.target.textContent);
        dispatch(setProductsByCategory(e.currentTarget.id));
        navigate('/');
    }

  return (
    <div className='navbar'>
        <div className={data==='mobilephonesandaccessories'?'category active':'category'} id='mobilephonesandaccessories' onClick={(e)=>handleActive(e)}>
            Mobile Phones & Accessories
        </div>
        <div className={data==='electronicsandgadgets'?'category active':'category'} id='electronicsandgadgets' onClick={(e)=>handleActive(e)}>
            Electronics & Gadgets
        </div>
        <div className={data==='homeandkitchenappliances'?'category active':'category'} id='homeandkitchenappliances' onClick={(e)=>handleActive(e)}>
            Home & Kitchen Appliances
        </div>
        <div className={data==='beautyandpersonalcare'?'category active':'category'} id='beautyandpersonalcare' onClick={(e)=>handleActive(e)}>
            Beauty & Personal Care
        </div>
    </div>
  )
}
